import { CobaltIconBulletedListOutline } from '@cae/cobalt-react/icons/outline/CobaltIconBulletedListOutline';
import { CobaltIconCalendarOutline } from '@cae/cobalt-react/icons/outline/CobaltIconCalendarOutline';
import { CobaltIconHomeOutline } from '@cae/cobalt-react/icons/outline/CobaltIconHomeOutline';
import { CobaltIconLibraryOutline } from '@cae/cobalt-react/icons/outline/CobaltIconLibraryOutline';
import { CobaltIconBulletedListSolid } from '@cae/cobalt-react/icons/solid/CobaltIconBulletedListSolid';
import { CobaltIconCalendarSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCalendarSolid';
import { CobaltIconHomeSolid } from '@cae/cobalt-react/icons/solid/CobaltIconHomeSolid';
import { CobaltIconLibrarySolid } from '@cae/cobalt-react/icons/solid/CobaltIconLibrarySolid';
import { APP_ROUTES } from '@routes/routes.constants';

import type { AppSideNavigationItem } from '../AppSideNavigation.types';

/**
 * Train module navigation items (Trainee)
 *
 * Permissions from roles_permissions.md:
 * - Schedule_View_Own: View training overview page
 *
 * Note: Uses absolute paths
 * Pattern: /train/[route]
 *
 * Future: Add My Learning, Library, Records, etc.
 */
export const TRAIN_NAV: AppSideNavigationItem[] = [
  {
    label: 'Overview',
    path: APP_ROUTES.TRAIN_OVERVIEW,
    icon: CobaltIconHomeOutline,
    activeIcon: CobaltIconHomeSolid,
    permission: 'Schedule_View_Own',
  },
  {
    label: 'Schedule',
    path: APP_ROUTES.TRAIN_PILOT_SCHEDULE,
    icon: CobaltIconCalendarOutline,
    activeIcon: CobaltIconCalendarSolid,
    permission: 'Schedule_View_Own',
  },
  {
    label: 'Library',
    path: APP_ROUTES.TRAIN_LIBRARY,
    icon: CobaltIconLibraryOutline,
    activeIcon: CobaltIconLibrarySolid,
    permission: 'MyLearning_View_Own',
  },
  {
    label: 'Training and records',
    path: APP_ROUTES.TRAIN_RESERVATIONS,
    icon: CobaltIconBulletedListOutline,
    activeIcon: CobaltIconBulletedListSolid,
    permission: 'MyLearning_View_Own',
  },
];
